import { useState } from 'react';
import { useSelector } from 'react-redux';
import classes from './AdminActionsDrawer.module.css';

const AdminActionsDrawer = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { texts } = useSelector(state => state.translate);

  return (
    <div className={classes.Drawer}>
      <button
        type="button"
        className={classes.Toggle}
        aria-expanded={isOpen}
        onClick={() => setIsOpen(open => !open)}
      >
        <span>{texts.adminSaveAndExport}</span>
        <span
          className={`${classes.Chevron} ${isOpen ? classes.ChevronOpen : ''}`}
          aria-hidden="true"
        >
          ⌃
        </span>
      </button>
      <div className={`${classes.Content} ${isOpen ? classes.ContentOpen : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default AdminActionsDrawer;
